/* istanbul ignore file */
import { optional as codecOptional, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { AssignmentPercentageGradingSettings } from './AssignmentPercentageGradingSettings';
import { AssignmentPointsGradingSettings } from './AssignmentPointsGradingSettings';
import { AssignmentSubmissionMode } from './AssignmentSubmissionMode';
import { Disabled } from './Disabled';
import { Enabled } from './Enabled';
import { EnabledHandinRequirements } from './EnabledHandinRequirements';
import { EnabledPeerFeedback } from './EnabledPeerFeedback';
import { EnabledRubric } from './EnabledRubric';
import { EnabledSolution } from './EnabledSolution';
import { UploadConfiguration } from './UploadConfiguration';
const CommunityLibraryItemParser = /* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ parsers.object([
    [
        'fileToLoadFirst',
        /* #__PURE__ */ parsers.maybeNull(codecString),
        'file_to_load_first',
    ],
    [
        'description',
        /* #__PURE__ */ parsers.taggedUnion('tag', [
            ['enabled', Enabled],
            ['disabled', Disabled],
        ]),
    ],
    [
        'handinRequirements',
        /* #__PURE__ */ parsers.taggedUnion('tag', [
            ['enabled', EnabledHandinRequirements],
            ['disabled', Disabled],
        ]),
        'handin_requirements',
    ],
    ['uploadConfiguration', UploadConfiguration, 'upload_configuration'],
    [
        'rubric',
        /* #__PURE__ */ parsers.taggedUnion('tag', [
            ['enabled', EnabledRubric],
            ['disabled', Disabled],
        ]),
    ],
    [
        'solution',
        /* #__PURE__ */ parsers.taggedUnion('tag', [
            ['enabled', EnabledSolution],
            ['disabled', Disabled],
        ]),
    ],
    [
        'peerFeedback',
        /* #__PURE__ */ parsers.taggedUnion('tag', [
            ['enabled', EnabledPeerFeedback],
            ['disabled', Disabled],
        ]),
        'peer_feedback',
    ],
    [
        'gradingSettings',
        /* #__PURE__ */ parsers.taggedUnion('scale', [
            ['percentage', AssignmentPercentageGradingSettings],
            ['points', AssignmentPointsGradingSettings],
        ]),
        'grading_settings',
    ],
    [
        'submissionMode',
        /* #__PURE__ */ codecOptional(AssignmentSubmissionMode),
        'submission_mode',
    ],
]));
export class CommunityLibraryItem extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CommunityLibraryItemParser.decode(input).map(res => new CommunityLibraryItem(res));
    }
    static unsafeDecode(input) {
        return CommunityLibraryItem.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CommunityLibraryItemParser.encode(data);
    }
    static schema() {
        return CommunityLibraryItemParser.schema();
    }
}
